import { JustDigits } from '../../../../filters/justdigits'

JustDigits()

export default {
  name: 'nineth',
  data: function() {
    return {
      measureUnit: '',
      select_heating_type: [ ],
      waterCustomCost: false,
      waterCost: 0,
      energyCost: 0,
      heatingType: {},
      costMap: {}
    }
  },
  props: ['water_management', 'landingText'],
  watch: {
    $route: function() {
      // find meas unit when language change
      let measureUnits = this.$store.getters.measUnitFile
      this.measureUnit = measureUnits[this.$route.params.id]
      // find default values when language change
      return this.$http.get('defaultcost', {
        params: {
          country_code: this.$route.params.id.split('_')[1]
        },
        credentials: 'include'
      })
        .then(response => {
          if (response && response.body) {
            console.log('GET /default', response.body)
            this.waterCost = response.body.water_cost
            this.costMap = response.body.heating_costs
            this.heatingType = response.body.heating_type_default
            this.energyCost = this.costMap[this.heatingType.id].energy_cost
          }
        })
      // error callback
        .catch(err => {
          console.log(err)
        })
    }
  },
  computed: {
  },
  methods: {
    goToTenth: function() {
      this.water_management.measure_unit = this.measureUnit
      this.water_management.heating_type = this.heatingType

      if (this.waterCost !== 0 && typeof this.waterCost === 'string') {
        let newValue = this.waterCost.replace(/[^0-9.]/ig, '')
        this.water_management.water_cost = newValue
      } else {
        this.water_management.water_cost = this.waterCost
      }

      if (this.energyCost !== 0 && typeof this.energyCost === 'string') {
        let newValue = this.energyCost.replace(/[^0-9.]/ig, '')
        this.water_management.energy_cost = newValue
      } else {
        this.water_management.energy_cost = this.energyCost
      }

      this.$emit('change-component', 'tenth-component', this.water_management)
    },

    resetDefault: function() {
      this.heatingType = ''
      this.waterCost = 0
      this.energyCost = 0
    },

    Onchange: function(event) {
      if (this.heatingType.id && this.costMap[this.heatingType.id]) {
        this.energyCost = this.costMap[this.heatingType.id].energy_cost
      }
    }
  },
  mounted: function() {
    let units = this.$store.getters.measUnitFile
    this.measureUnit = units[this.$route.params.id]
  },
  beforeMount: function() {
    this.$http.get('defaultcost', {
      params: {
        country_code: this.$route.params.id.split('_')[1]
      },
      credentials: 'include'
    })
      .then(response => {
        if (response && response.body) {
          console.log('GET /default', response.body)
          this.waterCost = response.body.water_cost
          this.costMap = response.body.heating_costs
          this.heatingType = response.body.heating_type_default
          this.energyCost = this.costMap[this.heatingType.id].energy_cost
        }
      })
      .then(() => {
        return this.$http.get('heatingtypes')
      })
      .then(response => {
        if (response && response.body) {
          console.log('GET /heatingtypes', response.body)
          this.select_heating_type = response.body
        }
      })
    // error callback
      .catch(err => {
        console.log(err)
      })

    let units = this.$store.getters.measUnitFile
    this.measureUnit = units[this.$route.params.id]
    this.waterCost = this.water_management.water_cost
    this.waterCustomCost = false
    this.energyCost = this.water_management.energy_cost
  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/nineth/nineth.js